import React, { useEffect, useState } from 'react';
import { Nav } from 'react-bootstrap';

import CentredSpinner from '../../Components/CentredSpinner';
import DataTable from '../../DataTable/datatable.component';
import SelectFilter from '../../DataTable/datatable.selectfilter';
import BusinessUnitEditDialog from '../../Dialogs/Configuration/BusinessUnitEditDialog';
import { useBusinessUnits } from '../../Utilities/useBusinessUnits';
import CommonConfigPage from './CommonConfigPage';

interface BusinessUnitsTableProps {
    showEditDialog: any,
    includeDeleted: boolean,
    refresh:any,
}

function BusinessUnitsTable({ showEditDialog, includeDeleted, refresh }: BusinessUnitsTableProps) {
    const { loading, businessUnits, getBusinessUnits } = useBusinessUnits(includeDeleted);
    const [tableData, setTableData] = useState(businessUnits);

    useEffect(() => {
        getBusinessUnits();
    }, [getBusinessUnits, refresh]);

    useEffect(() => {
        setTableData(businessUnits);
    }, [businessUnits]);

    const tableColumns = [
        {
            Header: 'Name',
            accessor: 'name',
            filter: 'includesString',
            Cell: (props:any) => {
                return (<Nav><Nav.Link onClick={() => { showEditDialog(props.row.original); }}>{props.value}</Nav.Link></Nav>)
            }
        },
        {
            Header: 'Code',
            accessor: 'code',
            filter: 'includesString'
        },
        {
            Header: 'Type',
            accessor: 'businessUnitType',
            Filter: SelectFilter 
        },
        {
            Header: 'AD Group Name',
            accessor: 'adGroupName',
            filter: 'includesString'
        }
    ];

    const getRowProps = (row: any) => {
        if (row.original.isDeleted)
            return { className: "deleted" };

        return {};
    };

    return !loading
        ? <DataTable tableColumns={tableColumns} tableData={tableData} getRowProps={getRowProps} />
        : <CentredSpinner />;
}

function BusinessUnitConfiguration() {
    const getNewBusinessUnit = () => {
        return { businessUnitId: null, name: "", code: "", adGroupName: null, isDeleted: false }
    };

    return (
        <CommonConfigPage
            title="Business Units"
            Table={BusinessUnitsTable}
            Dialog={BusinessUnitEditDialog}
            getNewConfigObject={getNewBusinessUnit}
        />
    );
}

export default BusinessUnitConfiguration;